import { Stat } from '@/components/ui/Stat';
import { useBillingOverview } from '@/hooks/useAdminBilling';
import { formatPercentage } from '@/utils/formatters';
import { UserMinus } from 'lucide-react';

export function ChurnRateCard() {
  const { data } = useBillingOverview();
  // Billing overview API returns { mrr, arr, churn, ... } directly
  return (
    <Stat
      label="Churn"
      value={data?.churn != null ? formatPercentage(data.churn) : '--'}
      icon={<UserMinus className="h-5 w-5" />}
    />
  );
}
